import { createExperimentContext } from 'src/libs/ExperimentConfig';
export const { ExperimentConfigProvider, useExperimentConfig } =
  createExperimentContext([
    {
      name: 'growth-placement-assertive-flow-10-days',
      experimentGroupRangeConfig: {
        'employer-seek-au': ['3', '4'],
        'employer-seek-nz': ['3', '4'],
        'employer-seek-hk': ['3', '4'],
        'employer-seek-id': ['3', '4'],
        'employer-seek-th': ['3', '4'],
        'employer-seek-sg': ['3', '4'],
        'employer-seek-ph': ['3', '4'],
        'employer-seek-my': ['3', '4'],
      },
    },
    {
      name: 'growth-placement-assertive-flow-25-days',
      experimentGroupRangeConfig: {
        'employer-seek-au': ['1', '9'],
        'employer-seek-nz': ['1', '9'],
        'employer-seek-hk': ['1', '9'],
        'employer-seek-id': ['1', '9'],
        'employer-seek-th': ['1', '9'],
        'employer-seek-sg': ['1', '9'],
        'employer-seek-ph': ['1', '9'],
        'employer-seek-my': ['1', '9'],
      },
    },
    {
      name: 'growth-placement-passive-flow',
      experimentGroupRangeConfig: {
        'employer-seek-au': ['2', '8'],
        'employer-seek-nz': ['2', '8'],
        'employer-seek-hk': ['2', '8'],
        'employer-seek-id': ['2', '8'],
        'employer-seek-th': ['2', '8'],
        'employer-seek-sg': ['2', '8'],
        'employer-seek-ph': ['2', '8'],
        'employer-seek-my': ['2', '8'],
      },
    },
  ]);
